<script setup>
import { computed } from 'vue';
import { SUBSCRIPTION_CANCELLED } from '../../utils/constants';
import { default as t } from '../../utils/translationStrings';
import InvoicesList from './InvoicesList';

// Props.
const props = defineProps({
  accountSpecs: {
    type: Object,
    default: () => {},
  },
  shopUrl: {
    type: String,
    required: true,
  },
  subscriptionType: {
    type: String,
    required: true,
  },
  user: {
    type: Object,
    required: true,
    default: () => {},
  },
});

// Computed.
const paymentMethodInformation = computed(() => {
  const baseInfo = {
    paymentMethod: props.accountSpecs?.payment,
  };

  // If subscription is active, display user address.
  if (!props.accountSpecs?.isTrial) {
    return {
      ...baseInfo,
      billingAddress: `
        ${props.user?.defaultBillingAddress?.company}<br>
        ${props.user?.defaultBillingAddress?.street}<br>
        ${props.user?.defaultBillingAddress?.zipcode} ${props.user?.defaultBillingAddress?.city}<br>
        ${props.user?.defaultBillingAddress?.country.name}`,
    };
  }

  return baseInfo;
});
</script>

<template>
  <div class="payment-information">
    <div class="dashboard-page__section dashboard-page__section--payment-info">
      <h2>{{ t.dashboardPayment.paymentInfo }}</h2>
      <div
        v-for="(item, key) in paymentMethodInformation"
        class="dashboard-page__info-item"
        :class="`dashboard-page__info-item--${subscriptionType}`"
        :key="key">
        <!-- Labels. -->
        <div class="dashboard-page__label">{{ t.dashboardPayment[key] }}:</div>

        <!-- Values. -->
        <div class="dashboard-page__value">
          <!-- If the payment method is credit card, display some additional info. -->
          <template v-if="key === 'paymentMethod'">
            <p>{{ item.name }}</p>
            <div v-if="item?.cardData" class="dashboard-page__value-info">
              <p>
                <strong>
                  {{ t.dashboardPayment.cardData }}
                </strong>
                <br />
                <span v-html="item.cardData?.img"></span>
                {{ item.cardData.label }}
                <br />
                {{ item.cardData.cardNumber }}
                <br />
                {{ item.cardData.owner }}
              </p>
            </div>
          </template>
          <p v-else v-html="item"></p>
        </div>

        <!-- Actions. -->
        <div
          v-if="
            key === 'paymentMethod' &&
            !accountSpecs?.isTrial &&
            subscriptionType !== SUBSCRIPTION_CANCELLED
          "
          class="dashboard-page__action">
          <a :href="`${shopUrl}/update/subscription/payment`" target="_blank">
            {{ t.dashboardPayment.managePaymentMethod }}
          </a>
        </div>
      </div>
    </div>

    <div class="dashboard-page__section dashboard-page__section--invoices">
      <h2>{{ t.dashboardPayment.latestInvoices }}</h2>

      <!-- Invoices list. -->
      <div class="dashboard-page__list dashboard-page__invoices">
        <InvoicesList :shop-url="shopUrl" />
      </div>
    </div>
  </div>
</template>
